import * as React from "react";
import Dropzone from "react-dropzone";
import {LoadableProps} from "../common/props/LoadableProps";
import FormButtonsView from "../ui/form/FormButtonsView";
import ButtonTertiary from "../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {OnSuccess} from "../../store/action/actionHelpers";
import Spinner from "../../hiberUiKit/src/atoms/Spinner/Spinner";

const spinner = require("./../../../resources/hiber/img/spinner-orange.png");

interface ComponentProps {
	/**
	 * Upload button click action
	 * @param {File[]} files Files to upload
	 * @param {(file: File) => void} onFileReject on fail upload file callback
	 * @param {OnSuccess} onSuccess on success upload all files
	 */
	onUpload: (files: File[], onFileReject: (file: File) => void, onSuccess: OnSuccess) => void;
	/**
	 * On cancel callback
	 */
	onCancel: () => void
	/**
	 * Indicates if files are uploading
	 */
	filesUploading: boolean;
}

interface State {
	/**
	 * Array with uploaded files
	 */
	acceptedFiles: File[];
	/**
	 * Array with rejected files
	 */
	rejectedFiles: File[];
}

type Props = ComponentProps & LoadableProps;

export default class FileSelector extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {acceptedFiles: [], rejectedFiles: []};
		this.onDrop = this.onDrop.bind(this);
		this.clearFiles = this.clearFiles.bind(this);
	}

	render() {
		return (

			<div>
				<Dropzone onDrop={this.onDrop}
						  accept={"image/*,.pdf,.doc,.docx,.xls,.xlsx,application/pdf,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document"}
						  className={"dropzone"}
						  activeClassName={"active"}>
					<div className={"t-link"}>Click here to select files to upload or simply drop them in.</div>
					{this.props.loading && <Spinner size={36} imgUrl={spinner}/>}
				</Dropzone>
				{this.renderAcceptedFiles()}
				{this.renderRejectedFiles()}
				<FormButtonsView align={"right"}>
					<ButtonTertiary label="Cancel"
									onClick={() => {
										this.props.onCancel();
										this.clearFiles()
									}}
									disabled={this.props.filesUploading ||
									(!this.state.acceptedFiles.length && !this.state.rejectedFiles.length)}/>
					<ButtonPrimary label={"Upload"}
								   onClick={() => this.props.onUpload(this.state.acceptedFiles,
									   (file) => {this.setState({rejectedFiles: this.state.rejectedFiles.concat(file)})},
									   this.clearFiles)}
								   disabled={!this.state.acceptedFiles.length || this.props.filesUploading}/>
				</FormButtonsView>
			</div>
		)
	}

	renderAcceptedFiles() {
		const filesLength = this.state.acceptedFiles.length;
		return (
			filesLength > 0 &&
			<div>
				<h4>{filesLength} {filesLength > 1 ? "files" : "file"} selected</h4>
				{this.state.acceptedFiles.map((file, index) => {return (<div key={index}>{file.name}</div>)})}
			</div>
		)
	}

	renderRejectedFiles() {
		const filesLength = this.state.rejectedFiles.length;
		return (
			filesLength > 0 &&
			<div style={{paddingTop: "20px"}}>
				<h4>{`Unsupported ${filesLength > 1 ? "files" : "file"} - will not be uploaded`}</h4>
				{this.state.rejectedFiles.map((file, index) => {return (<div key={index}>{file.name}</div>)})}
			</div>
		)
	}

	onDrop(acceptedFiles: File[], rejectedFiles: File[]) {
		this.setState({
			acceptedFiles: this.state.acceptedFiles.concat(acceptedFiles),
			rejectedFiles: this.state.rejectedFiles.concat(rejectedFiles)
		})
	}

	clearFiles() {
		this.setState({acceptedFiles: [], rejectedFiles: []});
	}
}